const Experience = () => {
    return (
        <>
            <h2 data-transl="" class="mb-5">
                Experience
            </h2>
            <div className="flex flex-row mb-6 justify-between 926:flex-col 926:gap-2.5">
                <div className="w-48 926:mb-2.5">Oct 2024 - Present</div>
                <div className="w-full">
                    <div className="mb-2.5 font-bold">CAPGEMINI</div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm font-bold">
                        Backend Developer
                    </div>
                    <ul className="pl-5">
                        <li className="list-disc md:text-sm">
                            Developed new backend endpoints using Node.js,
                            following the MVC pattern and deploying via Azure
                            Function App.
                        </li>
                        <li className="list-disc md:text-sm">
                            Wrote component and integration tests for endpoints
                            using Jest to ensure code quality and reliability.
                        </li>
                        <li className="list-disc md:text-sm">
                            Worked with MongoDB, crafting efficient queries and
                            setting up aggregation pipelines for data
                            processing.
                        </li>
                        <li className="list-disc md:text-sm">
                            Maintained a client project, troubleshooting issues
                            related to incorrect data received in Azure Event
                            Hub from external sources.
                        </li>
                        <li className="list-disc md:text-sm">
                            Configured YAML files for deploying endpoints in
                            Azure API Manager.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="flex flex-row mb-6 justify-between 926:flex-col 926:gap-2.5">
                <div className="w-48 926:mb-2.5">Aug 2022 - Oct 2024</div>
                <div className="w-full">
                    <div className="mb-2.5 font-bold">
                        CODE-DIRECTORY PROJECT
                    </div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm font-bold">
                        Fullstack & Mobile developer
                    </div>
                    <ul className="pl-5">
                        <li className="list-disc md:text-sm">
                            Created a personal web application
                            code-directory.com for interview preparation using
                            React.js, later migrated to Next.js
                        </li>
                        <li className="list-disc md:text-sm">
                            Developed and published a mobile application on
                            React Native, available on App Store and Play
                            Market.
                        </li>
                        <li className="list-disc md:text-sm">
                            Built a Back-end in Node.js using Passport.js and
                            Express.js for user authentication.
                        </li>
                        <li className="list-disc md:text-sm">
                            Designed and maintain a PostgreSQL database with
                            questions, answers, code examples, and user
                            accounts.
                        </li>
                        <li className="list-disc md:text-sm">
                            Deployed Docker containers on a Linux server,
                            configured Nginx web server, and set up SSL for
                            HTTPS protocol.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="flex flex-row mb-6 justify-between 926:flex-col 926:gap-2.5">
                <div className="w-48 926:mb-2.5">Aug 2021 - Oct 2024</div>
                <div className="w-full">
                    <div className="mb-2.5 font-bold">AREX Sp.z.o.o</div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm font-bold">
                        Electronics Assembler
                    </div>
                    <ul className="pl-5">
                        <li className="list-disc md:text-sm">
                            Performed maintenance and setup of machines for
                            mounting SMD components on printed circuit boards,
                            which enhanced my technical skills and attention to
                            detail.
                        </li>
                        <li className="list-disc md:text-sm">
                            Significantly improved communication and teamwork
                            skills, positively impacting my overall professional
                            competencies.
                        </li>
                        <li className="list-disc md:text-sm">
                            Living and working in a foreign country fostered
                            flexibility, adaptability, and self-confidence.
                        </li>
                    </ul>
                </div>
            </div>
            <div className="flex flex-row mb-6 justify-between 926:flex-col 926:gap-2.5">
                <div className="w-48 926:mb-2.5">Dec 2020 - Jul 2021</div>
                <div className="w-full">
                    <div className="mb-2.5 font-bold">NanoTech</div>
                    <div className="text-justify leading-relaxed max-w-5xl md:text-sm font-bold">
                        Frontend developer
                    </div>
                    <ul className="pl-5">
                        <li className="list-disc md:text-sm">
                            Developed a web application in React that displays
                            the part index and its components after scanning a
                            QR code, integrating with a REST API to retrieve and
                            update component data efficiently.
                        </li>
                        <li className="list-disc md:text-sm">
                            Implemented functionality for searching part
                            components using SQL queries.
                        </li>
                        <li className="list-disc md:text-sm">
                            Actively improved skills as part of a development
                            team.
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Experience
